import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";
import { ReactNode } from "react";

import { theme } from "./theme";

interface IProps {
  children: ReactNode;
}

const ThemeProvider = ({ children }: IProps) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
